<template>
  <div style="padding-top: 10px">
    <div class="fchart-wrapper" style="margin-bottom: 24px">
      <Table
        border
        :loading="loading"
        :columns="tableColumns"
        :data="tableData"
        highlight-row
      >
        <template slot-scope="{ row, index }" slot="action">
          <span
            class="pointer"
            type="text"
            size="small"
            @click="handleDeal(row)"
            >趋势</span
          >
        </template>
      </Table>
    </div>
    <Modal
      v-model="modal"
      footer-hide
      :title="areaTitle"
      width="80"
      @on-cancel="asyncOK"
    >
      <div class="trend-statistics-wrapperT">
        <div class="choose-containerT">
          <DatePicker
            type="daterange"
            :value="timeValueArr"
            show-week-numbers
            placement="bottom-end"
            placeholder="请选择日期"
            style="width: 200px"
            :options="pickerOptions"
            transfer
            @on-change="changeDateHandle"
          ></DatePicker>
          <Select
            v-model="targetValue"
            multiple
            style="width: 560px"
            class="select-self"
            @on-change="changeHandle"
            transfer
          >
            <Option
              v-for="item in targetValueList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="chart-container" v-if="targetValue.length > 0">
          <div class="fchart-bi" id="fchart" style="height: 455px" ref="chartLine">
            出勤统计
          </div>
        </div>
        <div
          style="height: 455px"
          v-if="targetValue.length == 0"
          class="no-data-style"
        >
          暂无数据
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { format } from "../../../utils/forMat";
// let echarts = require("echarts");
let nameRateArr = [
  "项目更新率",
  "项目停工率",
  "项目经理到岗率",
  "项目总监到岗率",
  "项目经理和总监理工程师到岗率",
];
export default {
  data() {
    return {
      xAxisData: [],
      yAxisData: [],
      seriesData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      singleOrdouble: false,
      resultArr: [],
      lineAreaCode: "",
      lineAreaType: "",
      countArr: [
        "avgWorkerCount",
        "notSetProjectManagersNum",
        "notSetProjectDirectorNum",
        "setProjectManagersNotCertifiedArchitectNum",
        "setProjectDirectorNotRegisteredSupervisorNum",
        "projectExceedNoCheckMessageNum",
        "supplierExceedNoJointMessageNum",
        'supplierExceedNoCheckMessageNum'
      ],
      rateArr: [
        "atendanceProjectsuperviseRate",
        "projectStopRate",
        "buildManagerAverageToPostRate",
        "supervisionManagerAverageToPostRate",
        "managerAndChiefInspectorAttendanceRate",
      ],
      timeValueArr: [],
      chartLine: null,
      modal: false,
      areaTitle: "",
      targetValue: ["atendanceProjectsuperviseRate", "projectStopRate"],
      targetValue1: ["atendanceProjectsuperviseRate", "projectStopRate"],
      targetValueList: [
        {
          value: "atendanceProjectsuperviseRate",
          label: "项目更新率",
        },
        {
          value: "projectStopRate",
          label: "项目停工率",
        },
        {
          value: "avgWorkerCount",
          label: "有考勤项目的平均上班工人数",
        },
        {
          value: "buildManagerAverageToPostRate",
          label: "项目经理到岗率",
        },
        {
          value: "supervisionManagerAverageToPostRate",
          label: "项目总监到岗率",
        },
        {
          value: "managerAndChiefInspectorAttendanceRate",
          label: "项目经理和总监理工程师到岗率",
        },
        {
          value: "notSetProjectManagersNum",
          label: "未设置项目经理的项目数",
        },
        {
          value: "notSetProjectDirectorNum",
          label: "未设置总监理工程师的项目数",
        },
        {
          value: "setProjectManagersNotCertifiedArchitectNum",
          label: "已设置但非注册建造师的项目数",
        },
        {
          value: "setProjectDirectorNotRegisteredSupervisorNum",
          label: "已设置但非注册监理工程师的项目数",
        },
        // {
        //   value: "projectExceedNoCheckMessageNum",
        //   label: "项目超期未审核预警",
        // },
        // {
        //   value: "supplierExceedNoJointMessageNum",
        //   label: "供应商超期未联调预警",
        // },
        // {
        //   value: 'supplierExceedNoCheckMessageNum',
        //   label: '供应商超期未审核办件数'
        // },
      ],
      tableData: [],
      newTime: [],
      newAreaCode: "",
      loading: false,
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "地区",
          key: "areaName",
          minWidth: 170,
          align: "left",
        },
        {
          title: "统计时间",
          key: "statisticsDate",
          minWidth: 190,
          align: "left",
        },

        {
          title: "在建项目数",
          key: "projectBuilding",
          minWidth: 130,
          align: "left",
        },
        {
          title: "已达标考核项",
          key: "qualifiedItem",
          minWidth: 130,
          align: "left",
        },
        {
          title: "未达标考核项",
          key: "unQualifiedItem",
          minWidth: 130,
          align: "left",
        },
        {
          title: "更新率",
          align: "center",
          children: [
            {
              title: "项目停工率",
              key: "projectStopRate",
              minWidth: 150,
              align: "left",
              render: (
                h,
                { row: { projectStopRate, projectStopRateTrend } }
              ) => {
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "50px",
                      },
                    },
                    projectStopRate + "%"
                  ),
                  h("Icon", {
                    props: {
                      type:
                        projectStopRateTrend == "1"
                          ? "md-arrow-round-up"
                          : projectStopRateTrend == "-1"
                          ? "md-arrow-round-down"
                          : "",
                    },
                    attrs: {
                      color:
                        projectStopRateTrend == "1" ? "#36F589" : "#FF5A5A",
                    },
                  }),
                ]);
              },
            },
            {
              title: "项目更新率",
              key: "projectAttendanceRate",
              minWidth: 150,
              align: "left",
              render: (
                h,
                { row: { projectAttendanceRate, projectAttendanceRateTrend } }
              ) => {
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "50px",
                      },
                    },
                    projectAttendanceRate + "%"
                  ),
                  h("Icon", {
                    props: {
                      type:
                        projectAttendanceRateTrend == "1"
                          ? "md-arrow-round-up"
                          : projectAttendanceRateTrend == "-1"
                          ? "md-arrow-round-down"
                          : "",
                    },
                    attrs: {
                      color:
                        projectAttendanceRateTrend == "1"
                          ? "#36F589"
                          : "#FF5A5A",
                    },
                  }),
                ]);
              },
            },
            {
              title: "有考勤数据项目的平均上班工人数",
              key: "averageWorkerCount",
              minWidth: 150,
              align: "left",
              render: (
                h,
                { row: { averageWorkerCount, averageWorkerCountTrend } }
              ) => {
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "50px",
                      },
                    },
                    averageWorkerCount
                  ),
                  h("Icon", {
                    props: {
                      type:
                        averageWorkerCountTrend == "1"
                          ? "md-arrow-round-up"
                          : averageWorkerCountTrend == "-1"
                          ? "md-arrow-round-down"
                          : "",
                    },
                    attrs: {
                      color:
                        averageWorkerCountTrend == "1" ? "#36F589" : "#FF5A5A",
                    },
                  }),
                ]);
              },
            },
          ],
        },
        {
          title: "管理人员到岗率",
          align: "center",
          children: [
            {
              title: "项目经理到岗率",
              key: "managerToPostRate",
              minWidth: 150,
              align: "left",
              render: (
                h,
                { row: { managerToPostRate, managerToPostRateTrend } }
              ) => {
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "50px",
                      },
                    },
                    managerToPostRate + "%"
                  ),
                  h("Icon", {
                    props: {
                      type:
                        managerToPostRateTrend == "1"
                          ? "md-arrow-round-up"
                          : managerToPostRateTrend == "-1"
                          ? "md-arrow-round-down"
                          : "",
                    },
                    attrs: {
                      color:
                        managerToPostRateTrend == "1" ? "#36F589" : "#FF5A5A",
                    },
                  }),
                ]);
              },
            },
            {
              title: "总监理工程师到岗率",
              key: "chiefInspectorToPostRate",
              minWidth: 150,
              align: "left",
              render: (
                h,
                {
                  row: {
                    chiefInspectorToPostRate,
                    chiefInspectorToPostRateTrend,
                  },
                }
              ) => {
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "50px",
                      },
                    },
                    chiefInspectorToPostRate + "%"
                  ),
                  h("Icon", {
                    props: {
                      type:
                        chiefInspectorToPostRateTrend == "1"
                          ? "md-arrow-round-up"
                          : chiefInspectorToPostRateTrend == "-1"
                          ? "md-arrow-round-down"
                          : "",
                    },
                    attrs: {
                      color:
                        chiefInspectorToPostRateTrend == "1"
                          ? "#36F589"
                          : "#FF5A5A",
                    },
                  }),
                ]);
              },
            },
            {
              title: "项目经理和总监理工程师到岗率",
              key: "managerAndChiefInspectorToPostRate",
              minWidth: 150,
              align: "left",
              render: (
                h,
                {
                  row: {
                    managerAndChiefInspectorToPostRate,
                    managerAndChiefInspectorToPostRateTrend,
                  },
                }
              ) => {
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "50px",
                      },
                    },
                    managerAndChiefInspectorToPostRate + "%"
                  ),
                  h("Icon", {
                    props: {
                      type:
                        managerAndChiefInspectorToPostRateTrend == "1"
                          ? "md-arrow-round-up"
                          : managerAndChiefInspectorToPostRateTrend == "-1"
                          ? "md-arrow-round-down"
                          : "",
                    },
                    attrs: {
                      color:
                        managerAndChiefInspectorToPostRateTrend == "1"
                          ? "#36F589"
                          : "#FF5A5A",
                    },
                  }),
                ]);
              },
            },
          ],
        },
        {
          title: "关键岗位预警",
          align: "center",
          children: [
            {
              title: "未设置项目经理的项目数",
              key: "unSetManagerProjectCount",
              minWidth: 150,
              align: "left",
              render: (
                h,
                {
                  row: {
                    unSetManagerProjectCount,
                    unSetManagerProjectCountTrend,
                  },
                }
              ) => {
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "50px",
                      },
                    },
                    unSetManagerProjectCount
                  ),
                  h("Icon", {
                    props: {
                      type:
                        unSetManagerProjectCountTrend == "1"
                          ? "md-arrow-round-up"
                          : unSetManagerProjectCountTrend == "-1"
                          ? "md-arrow-round-down"
                          : "",
                    },
                    attrs: {
                      color:
                        unSetManagerProjectCountTrend == "1"
                          ? "#36F589"
                          : "#FF5A5A",
                    },
                  }),
                ]);
              },
            },
            {
              title: "未设置总监理工程师的项目数",
              key: "unSetChiefInspectorProjectCount",
              minWidth: 150,
              align: "left",
              render: (
                h,
                {
                  row: {
                    unSetChiefInspectorProjectCount,
                    unSetChiefInspectorProjectCountTrend,
                  },
                }
              ) => {
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "50px",
                      },
                    },
                    unSetChiefInspectorProjectCount
                  ),
                  h("Icon", {
                    props: {
                      type:
                        unSetChiefInspectorProjectCountTrend == "1"
                          ? "md-arrow-round-up"
                          : unSetChiefInspectorProjectCountTrend == "-1"
                          ? "md-arrow-round-down"
                          : "",
                    },
                    attrs: {
                      color:
                        unSetChiefInspectorProjectCountTrend == "1"
                          ? "#36F589"
                          : "#FF5A5A",
                    },
                  }),
                ]);
              },
            },
            {
              title: "已设置但非注册建造师的项目数",
              key: "noSpecialtyManagerProjectCount",
              minWidth: 150,
              align: "left",
              render: (
                h,
                {
                  row: {
                    noSpecialtyManagerProjectCount,
                    noSpecialtyManagerProjectCountTrend,
                  },
                }
              ) => {
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "50px",
                      },
                    },
                    noSpecialtyManagerProjectCount
                  ),
                  h("Icon", {
                    props: {
                      type:
                        noSpecialtyManagerProjectCountTrend == "1"
                          ? "md-arrow-round-up"
                          : noSpecialtyManagerProjectCountTrend == "-1"
                          ? "md-arrow-round-down"
                          : "",
                    },
                    attrs: {
                      color:
                        noSpecialtyManagerProjectCountTrend == "1"
                          ? "#36F589"
                          : "#FF5A5A",
                    },
                  }),
                ]);
              },
            },
            {
              title: "已设置但非注册监理工程师的项目数",
              key: "noSpecialtyChiefInspectorProjectCount",
              minWidth: 150,
              align: "left",
              render: (
                h,
                {
                  row: {
                    noSpecialtyChiefInspectorProjectCount,
                    noSpecialtyChiefInspectorProjectCountTrend,
                  },
                }
              ) => {
                return h("div", [
                  h(
                    "span",
                    {
                      style: {
                        display: "inline-block",
                        width: "50px",
                      },
                    },
                    noSpecialtyChiefInspectorProjectCount
                  ),
                  h("Icon", {
                    props: {
                      type:
                      noSpecialtyChiefInspectorProjectCountTrend == "1"
                          ? "md-arrow-round-up"
                          : noSpecialtyChiefInspectorProjectCountTrend == "-1"
                          ? "md-arrow-round-down"
                          : "",
                    },
                    attrs: {
                      color:
                      noSpecialtyChiefInspectorProjectCountTrend == "1"
                          ? "#36F589"
                          : "#FF5A5A",
                    },
                  }),
                ]);
              },
            },
          ],
        },
        // {
        //   title: "一地接入全省通用",
        //   align: "center",
        //   children: [
        //     {
        //       title: "项目超期未审核办件数",
        //       key: "projectNoCheckCount",
        //       minWidth: 150,
        //       align: "left",
        //       render: (
        //         h,
        //         { row: { projectNoCheckCount, projectNoCheckCountTrend } }
        //       ) => {
        //         return h("div", [
        //           h(
        //             "span",
        //             {
        //               style: {
        //                 display: "inline-block",
        //                 width: "50px",
        //               },
        //             },
        //             projectNoCheckCount
        //           ),
        //           h("Icon", {
        //             props: {
        //               type:
        //                 projectNoCheckCountTrend == "1"
        //                   ? "md-arrow-round-up"
        //                   : projectNoCheckCountTrend == "-1"
        //                   ? "md-arrow-round-down"
        //                   : "",
        //             },
        //             attrs: {
        //               color:
        //                 projectNoCheckCountTrend == "1" ? "#36F589" : "#FF5A5A",
        //             },
        //           }),
        //         ]);
        //       },
        //     },
        //     {
        //       title: "供应商超期未联调办件数",
        //       key: "supplierNoIntergratedTestCount",
        //       minWidth: 150,
        //       align: "left",
        //       render: (
        //         h,
        //         {
        //           row: {
        //             supplierNoIntergratedTestCount,
        //             supplierNoIntergratedTestCountTrend,
        //           },
        //         }
        //       ) => {
        //         return h("div", [
        //           h(
        //             "span",
        //             {
        //               style: {
        //                 display: "inline-block",
        //                 width: "50px",
        //               },
        //             },
        //             supplierNoIntergratedTestCount
        //           ),
        //           h("Icon", {
        //             props: {
        //               type:
        //                 supplierNoIntergratedTestCountTrend == "1"
        //                   ? "md-arrow-round-up"
        //                   : supplierNoIntergratedTestCountTrend == "-1"
        //                   ? "md-arrow-round-down"
        //                   : "",
        //             },
        //             attrs: {
        //               color:
        //                 supplierNoIntergratedTestCountTrend == "1"
        //                   ? "#36F589"
        //                   : "#FF5A5A",
        //             },
        //           }),
        //         ]);
        //       },
        //     },
        //     {
        //       title: "供应商超期未审核办件数",
        //       key: "supplierNoCheckCount",
        //       minWidth: 150,
        //       align: "left",
        //       render: (
        //         h,
        //         { row: { supplierNoCheckCount, supplierNoCheckCountTrend } }
        //       ) => {
        //         return h("div", [
        //           h(
        //             "span",
        //             {
        //               style: {
        //                 display: "inline-block",
        //                 width: "50px",
        //               },
        //             },
        //             supplierNoCheckCount
        //           ),
        //           h("Icon", {
        //             props: {
        //               type:
        //                 supplierNoCheckCountTrend == "1"
        //                   ? "md-arrow-round-up"
        //                   : supplierNoCheckCountTrend == "-1"
        //                   ? "md-arrow-round-down"
        //                   : "",
        //             },
        //             attrs: {
        //               color:
        //                 supplierNoCheckCountTrend == "1"
        //                   ? "#36F589"
        //                   : "#FF5A5A",
        //             },
        //           }),
        //         ]);
        //       },
        //     },
        //   ],
        // },
        {
          title: "操作",
          slot: "action",
          fixed: "right",
          align: "center",
          width: 100,
        },
      ],
    };
  },
  props: {
    time1: {
      type: Array,
      default: function () {
        return [];
      },
    },
    areaCode1: {
      type: String,
      default: "",
    },
  },
  components: {},
  computed: {},
  watch: {
    time1(curVal, oldVal) {
      if (curVal) {
        this.newTime = curVal;
        this.setDefaultDate();
      }
    },
    areaCode1(curVal, oldVal) {
      if (curVal) {
        this.newAreaCode = curVal;
        this.setDefaultDate();
      }
    },
    seriesData: {
      handler() {
        this.getChart();
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    getChart() {
      let that = this
      let echarts = require('echarts');
      let optionObj = {
        legend: {
          type: "scroll",
          orient: "horizontal",
          top: 5,
          left: 80,
        },
        tooltip: {
          axisPointer: {
            type: "shadow",
          },
          trigger: "axis",
          formatter: function (params) {
            let str = "";
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}: ${item.data}`;
              if (nameRateArr.includes(item.seriesName)) {
                str += "%";
              }
              str += idx === params.length - 1 ? "" : "<br/>";
            });
            return str;
          },
        },
        grid: {
          left: 60,
          right: 60,
          top: 40,
          bottom: 40,
        },
        xAxis: {
          name: "日期",
          nameTextStyle: {
            align: "right",
            padding: [28, -10, 0, 0],
          },
          /* 类目轴*/
          type: "category",
          axisLabel: {
            interval: 0,
            rotate: 38
          },
          axisTick: {
            alignWithLabel: true,
          },
          data: that.xAxisData,
        },
        yAxis: that.yAxisData,
        series: that.seriesData,
        // dataZoom:
        // that.xAxisData.length > 15
        //     ? [
        //         {
        //           startValue: 0,
        //           endValue: 10,
        //           type: "slider",
        //           show: true,
        //           xAxisIndex: [0],
        //           height: 10,
        //           bottom: 8,
        //           borderRadius: 5,
        //           showDataShadow: false,
        //           showDetail: false,
        //           realtime: true,
        //         },
        //       ]
        //     : [],
      };
      this.$nextTick(() => {
        document.getElementById("fchart").removeAttribute("_echarts_instance_");
        this.chartLine = echarts.init(that.$refs.chartLine);
        optionObj && this.chartLine.setOption(optionObj);
        this.chartLine.showLoading();
        this.chartLine.hideLoading();
      })
    },
    asyncOK() {
      this.targetValue = this.targetValue1;
    },
    setDefaultDate() {
      let param = {
        startDate: this.newTime[0] ? this.newTime[0] : "",
        endDate: this.newTime[1] ? this.newTime[1] : "",
        areaCode: this.areaCode1,
      };
      this.loading = true;
      this.axios({
        method: "post",
        url: "/gd/trendStatistics/queryTrendStatisticsList",
        data: param,
      })
        .then((response) => {
          if (response.data.success) {
            this.tableData = response.data.data;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleDeal(row) {
      this.modal = true;
      this.lineAreaCode = row.areaCode;
      this.areaTitle = row.areaName + "趋势统计";
      this.targetValue = this.targetValue1;
      window.addEventListener("resize", this.resize);
      window.addEventListener("load", this.resize);
      /*加载完成自适应*/
      this.$nextTick(() => {
        this.resize();
      });
      this.getTimeData();
      this.queryTrendStatisticsLineData();
    },
    changeDateHandle(e) {
      if (e[0] == "" || e[1] == "") {
        return this.$Message.warning({
          content: "请选择日期范围！",
        });
      }
      let start = Date.parse(e[0]);
      let end = Date.parse(e[1]);
      let range = 86400000 * 31;
      if (end - start > range) {
        return this.$Message.warning({
          content: "日期范围不能超过31天！",
          duration: 3,
        });
      }
      this.timeValueArr = e;
      this.queryTrendStatisticsLineData();
    },
    // echarts 适应
    resize() {
      this.chartLine.resize();
    },
    changeHandle() {
      if (this.targetValue.length == 0) {
        return;
      }
      this.handleyYAxis();
      this.handleySeries();
      //  增加可以重新绘制echarts但是 减少不会重新绘制 故增加此方法
      // document.querySelector(".fchart-bi").removeAttribute("_echarts_instance_");
      this.chartLine = null;
      this.getChart();
    },
    // 人员出勤监管查询
    queryTrendStatisticsLineData() {
      this.chartLine.showLoading();
      this.axios({
        method: "post",
        url: "/gd/trendStatistics/queryTrendStatisticsLineData",
        data: {
          areaCode: this.lineAreaCode,
          areaType: null,
          startDate:
            this.timeValueArr.length > 0
              ? this.timeValueArr[0]
              : this.$moment(
                  new Date().getTime() - 29 * 24 * 60 * 60 * 1000
                ).format("YYYY-MM-DD"),
          endDate:
            this.timeValueArr.length > 0
              ? this.timeValueArr[1]
              : this.$moment(new Date()).format("YYYY-MM-DD"),
        },
      }).then((response) => {
        if (response.data.data) {
          this.resultArr = response.data.data;
          let xData = [];
          this.resultArr.forEach((item) => {
            let str = item.workDate
            let date = str.slice(5)
            xData.push(date);
          });
          this.xAxisData = xData;
          this.handleyYAxis();
          this.handleySeries();
          this.getChart();
          this.chartLine.hideLoading();
        }
      });
    },
    handleyYAxis() {
      // this.optionObj.yAxis = [];
      this.yAxisData = [];
      let flagCount = this.targetValue.some((item) => {
        return this.countArr.includes(item);
      });
      if (flagCount) {
        this.yAxisData.push({
          name: "数量",
          type: "value",
          splitLine: {
            show: true, //网格线开关
            lineStyle: {
              type: "dashed",
            },
            axisLine: {
              show: false,
            },
          },
          axisLine: {
            show: false,
          },
          minInterval: 1,
        });
      }
      let flagRate = this.targetValue.some((item) => {
        return this.rateArr.includes(item);
      });
      if (flagRate) {
        this.yAxisData.push({
          name: "%",
          type: "value",
          // min: 0,
          // max: 100,
          splitNumber: 5,
          splitLine: {
            show: true, //网格线开关
            lineStyle: {
              type: "dashed",
            },
            axisLine: {
              show: false,
            },
          },
          axisLine: {
            show: false,
          },
          // minInterval: 1,
        });
      }
      if (flagCount && flagRate) {
        this.singleOrdouble = true;
      } else {
        this.singleOrdouble = false;
      }
    },
    handleySeries() {
      let series = [];
      this.targetValue.forEach((item) => {
        let dataArr = this.resultArr.map((ele) => {
          if (ele[item] && ele[item].toString().includes("%")) {
            ele[item] = ele[item].replace("%", "");
          }
          return ele[item] * 1;
        });
        let name = this.targetValueList.filter((k) => k.value == item)[0].label;
        let obj = {
          type: "line",
          name: name,
          smooth: true,
          keyValue: item,
          yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用。
          data: dataArr,
        };
        if (this.singleOrdouble) {
          if (this.countArr.includes(item)) {
            obj["yAxisIndex"] = 0;
          }
        } else {
          delete obj.yAxisIndex;
        }
        series.push(obj);
      });
      this.seriesData = series;
    },
    getTimeData() {
      //当前设定的日期时间
      let time2 = this.newTime[1]
      let d = new Date(Date.parse(time2));
      let e = new Date(Date.parse(time2) - 86400000 * 31);
      let year2, month2, day2;
      let year3, month3, day3;
      d.setTime(d.getTime());
      e.setTime(e.getTime());
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
      [year3, month3, day3] = [e.getFullYear(), e.getMonth(), e.getDate()];
      let timeChanges1 = new Date(year2, month2, day2, 0);
      let timeChanges2 = new Date(year3, month3, day3, 0);
      this.timeValueArr = [
        format(timeChanges2, "yyyy-MM-dd"),
        format(timeChanges1, "yyyy-MM-dd"),
      ];
    },
  },
};
</script>
<style lang="less">
.trend-statistics-wrapperT {
  .choose-containerT {
    display: flex;
    justify-content: flex-end;
    .select-self {
      .ivu-select-selection {
        height: 32px;
        overflow: auto;
      }
    }
  }
}
</style>

